var map = {
	"./addressHomeIcon.svg": "7ef1",
	"./arrowLeft.svg": "497a",
	"./arrowNewsletter.svg": "63de",
	"./arrowRight.svg": "6845",
	"./arw-dx.svg": "f352",
	"./arw-sx.svg": "e1b4",
	"./boltEmpty.svg": "4492",
	"./boltFull.svg": "dade",
	"./calendarHomeIcon.svg": "583a",
	"./en.png": "4815",
	"./eventBannerHomeIcon.svg": "b996",
	"./expand-less.svg": "5a04",
	"./expand-more.svg": "8568",
	"./experienceBannerHomeIcon.svg": "2ff5",
	"./gift.svg": "fb5c",
	"./it.png": "7e31",
	"./languageIcon.svg": "b9ef",
	"./locationEmptyIcon.svg": "4b27",
	"./locationIcon.svg": "8a17",
	"./markerClusterIcon.png": "9692",
	"./markerClusterIcon.svg": "cf8e",
	"./markerIcon.svg": "3cf3",
	"./markerIconWhite.svg": "ab8b",
	"./markerIconWhiteIB.svg": "be9b",
	"./markerIconWhiteMany.svg": "0e59",
	"./markerIconWhiteManyIB.svg": "9a47",
	"./news-icon.png": "fbcd",
	"./paymentKoIcon.svg": "a031",
	"./paymentOkIcon.svg": "a3e2",
	"./roomBannerHomeIcon.svg": "137c",
	"./searchHomeIcon.svg": "5bdd",
	"./shareHomeIcon.svg": "921f",
	"./tastingBannerHomeIcon.svg": "ed47",
	"./timeIcon.svg": "fbeb",
	"./userAvatarIcon.svg": "3212"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";